export const CTA_WORDING = {
  RATE_MODAL: {
    TITLE: 'Know someone that would love this?',
    TEXT: 'Tell them how much you enjoyed this when you share it with a friend',
    CTA_TEXT: 'Share Meal'
  },
  FAVORITES: {
    TITLE: 'Glad you like it!',
    TEXT: 'Tell them how much you enjoyed this when you share it with a friend',
    CTA_TEXT: 'Share Meal'
  }
}
